import { Map as ImmutableMap } from 'immutable';
import { StagingActionTypes } from '../actions/StagingActions';
export default function stagedChanges(state = ImmutableMap(), action) {
  switch (action.type) {
    case StagingActionTypes.STAGE_CHANGE:
      return state.set(action.payload.changeKey, action.payload.data);
    case StagingActionTypes.CLEAR_CHANGE:
      return state.delete(action.payload.changeKey);
    case StagingActionTypes.CLEAR_ALL:
      return ImmutableMap();
    default:
      return state;
  }
}